import { Injectable } from "@angular/core";
import { TRANSFORM_TYPE } from "@pienso/ingest-types/transform.interface";
import { Transformer } from "./transformer.interface";

@Injectable({ providedIn: "root" })
export class TransformerRegistryService {
  public readonly transfomers: Transformer[] = [];
  private typeRegistry: { [type: string]: Transformer } = {}; // Maps TRANSFORM_TYPE to Transformers

  constructor() {}

  public register(transformer: Transformer) {
    this.transfomers.push(transformer);
    transformer.transformTypes.forEach((type) => (this.typeRegistry[type] = transformer));
  }

  transformerForType(type: TRANSFORM_TYPE): Transformer {
    return this.typeRegistry[type];
  }

  transformerForId(id: string): Transformer | undefined {
    return this.transfomers.find((t) => t.id === id);
  }
}
